import { useEffect, useState } from 'react';

export const useTouchTargetNoMove = (
  onClose: () => void,
  target: HTMLElement | null,
  ignoreTarget?: HTMLElement | null
) => {
  const [touchStarted, setTouchStarted] = useState(false);
  const [touchMoved, setTouchMoved] = useState(false);

  const handleTouchStart = () => setTouchStarted(true);
  const handleTouchMove = () => setTouchMoved(true);
  const handleTouchEnd = () => {
    touchStarted && !touchMoved && onClose();

    setTouchStarted(false);
    setTouchMoved(false);
  };
  const handleIgnoreTarget = (e: TouchEvent) => e.stopPropagation();

  useEffect(() => {
    if (!target) return;
    ignoreTarget &&
      ignoreTarget.addEventListener('touchstart', handleIgnoreTarget);
    target.addEventListener('touchstart', handleTouchStart);
    target.addEventListener('touchmove', handleTouchMove);
    target.addEventListener('touchend', handleTouchEnd);

    return () => {
      ignoreTarget &&
        ignoreTarget.removeEventListener('touchstart', handleIgnoreTarget);
      target.removeEventListener('touchstart', handleTouchStart);
      target.removeEventListener('touchmove', handleTouchMove);
      target.removeEventListener('touchend', handleTouchEnd);
    };
  }, [target, handleTouchEnd, ignoreTarget]);
};
